<!--
 * @Descripttion: 内嵌页面
 * @Author: jschen
 * @Date: 2021-08-29 16:04:09
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-08-31 18:09:09
-->
<template>
    <div :class="['page-monitoring-page', { isNavTop: isNav }]">
        <el-button v-show="isShowCloseBtn" class="close-btn" @click="closeClick">
            <i class="el-icon-close"></i>
        </el-button>
        <iframe
            id="_iframe"
            :src="url"
            frameborder="0"
            style="background-color: transparent; width: 100%; min-height: 100%"
            allowfullscreen="allowfullscreen"
        ></iframe>
    </div>
</template>

<script>
export default {
    name: "IframeWrapper",
    data() {
        return {
            url: "",
            isNav: false,
            isShowCloseBtn: false,
        };
    },
    watch: {
        $route(val) {
            this.url = val.query.url;
            this.isShowCloseBtn = val.query.closeBtn || false;
        },
    },
    created() {
        this.url = this.$route.query.url;
        this.isShowCloseBtn = this.$route.query.closeBtn || false;
        let that = this;
        if (this.url.includes("business-dynamics")) {
            this.isNav = true;
        }
        // 发起流程 页面关闭事件
        window.addEventListener("message", function(event) {
            if (event.data.eventName === "create-flow" && event.data.fromType === "flow") {
                that.$router.push({ name: "Home" });
            }
        });
    },
    methods: {
        closeClick() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.page-monitoring-page {
    margin-top: 48px;
    height: calc(100vh - 48px);
    overflow: hidden;
    position: relative;
    &.isNavTop {
        margin-top: 58px;
        height: calc(100vh - 15px);
    }

    .close-btn {
        top: 24px;
        right: 24px;
        padding: 12px;
        position: absolute;
        font-size: 24px;
        border-radius: 50%;
        color: #3a9e80;
        border: 1px solid #3a9e80;

        i {
            font-family: element-icons !important;
            speak: none;
            font-style: normal;
            font-weight: 400;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            vertical-align: baseline;
            display: inline-block;
            -webkit-font-smoothing: antialiased;
        }
    }
}
</style>
